import { useEffect } from 'react';
export const useFormAutoSave = (subscribe, onSync) => {
    useEffect(() => {
        const unsubscribe = subscribe({
            formState: {
                values: true,
            },
            callback: ({ values }) => {
                if (values) {
                    onSync(values);
                }
            },
        });
        return unsubscribe;
    }, [subscribe, onSync]);
};
